import { Fragment, useContext } from "react"
import { ActionButton, Button, Loading, Modal } from "../../../../../../../../../components"
import { FormSection } from "../../../../FormSection"
import * as yup from "yup"
import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import toast from "react-hot-toast"
import type { ListCategoryVendor } from "../../../../../types"
import { useApi, useToggle } from "../../../../../../../../../utils"
import { Render } from "../../../../../utils"
import { useDetail } from "../utils"

export function Update(props: { id: ListCategoryVendor, refetch: () => void  }) {
  const { isActive, toggle } = useToggle(false)

  return (
    <Fragment>
    <ActionButton.Update className="join-item" onClick={toggle} />
    {isActive && <ModalSection id={props.id} toggle={toggle} refetch={props.refetch}/>}
  </Fragment>
  )
}

function ModalSection(props: {
  id: ListCategoryVendor
  toggle: () => void
  refetch: () => void
}) {
  const { data, dataError, isLoading } = useDetail()

  return (
    <Modal isOpen title="EDIT CATEGORY VENDOR" size="xl" closeModal={props.toggle}>
      {isLoading || dataError ? (
        <Loading errorText={dataError} loading={isLoading} />
      ) : (
        <DataForm data={data!} id={props.id} toggle={props.toggle} refetch={props.refetch} />
      )}
    </Modal>
  )
}

function DataForm(props: {
  data: ListCategoryVendor
  id: ListCategoryVendor
  toggle: () => void
  refetch: () => void
}) {
  const api = useApi()
  const { toggle } = useContext(Render)

  const validationSchema = yup.object().shape({
    category_vendor_code: yup.string().label("Category vendor code").required().max(3, 'Maximum code is 3 characters'),
    category_vendor_name: yup.string().label("Category vendor name").required(),
  })
  const onSubmit = ( value: ListCategoryVendor ) => {
    return new Promise<void>((resolve) => {
      toast.promise(
        api.put(`/categoryvendor/edit?category_vendor_id=${props.id.category_vendor_id}`, 
        { 
          category_vendor_code: value.category_vendor_code, 
          category_vendor_name: value.category_vendor_name, 
          description: value.description, 
        }),
        {
          loading: "Loading...",
          success: (res) => res.data.message,
          error: (err) => {
            if (err.response && err.response.status === 400) {
              return err.response.data.message || "Bad Request";
            } else {
              return "An error occurred";
            }
          }
        }
      ).then(() => {
        props.toggle()
        props?.refetch && props.refetch()
        toggle()
      }).catch(() => {}).finally(resolve)
    })
  }
  const methods = useForm({
    defaultValues: props.id,
    resolver: yupResolver(validationSchema)
  })

  return (
    <FormProvider {...methods}>
      {/* @ts-ignore */}
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <FormSection isUpdate />

        <Modal.Footer className="text-end">
          <Button type="submit" color="primary" loading={methods.formState.isSubmitting ? "true" : undefined}>Save</Button>
        </Modal.Footer>
      </form>
    </FormProvider>
  )
}